<template>
    <div :class="marginType ? 'mgt-16' : 'mgt-34' " class="d-flex justify-content-end ">
        <button
            id="tipBtn" class="mdc-button mdc-button--outlined t-color-secondaryBtnText tipBtn b-radius4 h-30 min-w-64 pdl-12 pdr-12" tabindex="0"
            @click="showTip()" @keypress="showTip()">
            <span class="mdc-button__label">{{$t('1244')}}</span>
        </button>
    </div>
</template>

<script>
/**
 * 문항별 팁 공통 컴포넌트(question tip common component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCRipple} from '@material/ripple'
export default {
    props: ['tip', 'marginType'],

     mounted() {
        this.setMaterialUi()
    },

    methods: {
        showTip() {            
            let tipText = this.tip.text
            let tipfile = ''
            if (this.tip.file) {
                if (this.tip.file.contentType === 'image/jpeg' || this.tip.file.contentType === 'image/png') {
                    tipfile = `<div class="contents-mask mgb-16 independent-img-video-bd-radius"><img src="${this.tip.file.resourceUri}" class="w-full"></div>`
                } else if (this.tip.file.contentType === 'video/mp4') {
                    tipfile = `<div class="contents-mask mgb-16 independent-img-video-bd-radius"><video src="${this.tip.file.resourceUri}" controls id="hintVideo" class="w-full"></video></div>`
                }
            }
            let alertParams = {
                title: this.$t('1403'), // Refer to the hint!
                content: `${tipfile}${tipText}`,
                accept: this.$t('1404')
            }
            this.$alert(alertParams).then(() => {
                if (this.tip.file.contentType === 'video/mp4') {
                    document.getElementById('hintVideo').pause()
                }
            })
        },

         setMaterialUi() {
            const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                let button = new MDCRipple.attachTo(el)
                return button
            })
        },        
    }
}
</script>